import * as React from "react";
import { compareValues } from "../../../utils/sortingUtils";
import "../../../../assets/scss/components/generic/sort.scss";

export interface MarginSortProps {
	sortList: Array<any>; //array of type any
	sortKey: string; // key to sort
	colName: string;
	sortedColName: string | null;
	onSort: (data: Array<any>, sortState: ESortState, sortKey: string) => void;
}

export interface MarginSortState {
	sortState: ESortState;
}

export enum ESortState {
	// NORMAL,
	ASC,
	DESC
}

export function marginSort(
	initialData: Array<any>,
	sortState: ESortState,
	sortKey: string,
	onSort: (data: Array<any>, sortState: ESortState, sortKey: string) => void
) {
	if (sortState === ESortState.ASC || sortState === ESortState.DESC) {
		// sort in ascending or descending
		if (sortState === ESortState.DESC) {
			onSort(initialData.sort(compareValues(sortKey, "desc")), sortState, sortKey);
		} else {
			onSort(initialData.sort(compareValues(sortKey)), sortState, sortKey);
		}
	}
}

class MarginSort extends React.Component<MarginSortProps, MarginSortState> {
	state = {
		sortState: ESortState.ASC
	};

	onSortClick = () => {
		// set the state to next state
		// and then call sort function
		this.setState({ sortState: (this.state.sortState + 1) % 2 }, () =>
			marginSort(this.props.sortList, this.state.sortState, this.props.sortKey, this.props.onSort)
		);
	};

	render() {
		return (
			<div className="col_srt_cont">
				<button onClick={this.onSortClick}>
					<div className="col_sorting">
						<label className="col_nm">{this.props.colName}</label>
						<div className="sort_icons">
							<i className="edel-icon-sort-1"></i>
							<i className="edel-icon-sort-2"></i>
						</div>
					</div>
				</button>
			</div>
		);
	}
}
export default MarginSort;
